<template>
  <div>
    <NewNavbar variant="standard" />
    <nuxt />
    <OFooter
      :locale="locale"
      :year="$moment().format('YYYY')"
      :faq-column="footer.faqColumn"
      :how-does-it-work-column="footer.howDoesItWorkColumn"
      :legal-column="footer.legalColumn"
    />
  </div>
</template>

<script>
import NewNavbar from '@/components/NewNavbar'
import OFooter from '@/components/OFooter'
import { authenticated } from '@/mixins/layouts'
import footer from '@/mixins/footer'
import metaMixin from '@/mixins/meta'
import { mapState } from 'vuex'

export default {
  name: 'HomePageLayoutWithSignupButton',
  middleware: 'homepage',
  components: {
    NewNavbar,
    OFooter
  },
  mixins: [authenticated, footer, metaMixin],
  computed: {
    ...mapState('app', {
      locale: state => state.locale
    })
  },
  head () {
    return {
      title: this.metaTitle
    }
  }
}
</script>
